import React from 'react';
import reactDom from '../../../common/react/dom/index';
import Cart from '../../../components/frontend/cart';

export default function init() {
	reactDom(<Cart />, 'js-react-cart');
}
